/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as SwitchRouteImport } from './routes/switch';
import { Route as SignupRouteImport } from './routes/signup';
import { Route as NewBusinessRouteImport } from './routes/new-business';
import { Route as AuthRouteImport } from './routes/auth';
import { Route as AccountRouteImport } from './routes/account';
import { Route as R3dsRouteImport } from './routes/3ds';
import { Route as AccountVaultsRouteImport } from './routes/account.vaults';
import { Route as AccountTransferRouteImport } from './routes/account.transfer';
import { Route as AccountTransactionsRouteImport } from './routes/account.transactions';
import { Route as AccountTopupRouteImport } from './routes/account.topup';
import { Route as AccountStatementsRouteImport } from './routes/account.statements';
import { Route as AccountStandingOrdersRouteImport } from './routes/account.standing-orders';
import { Route as AccountSettingsRouteImport } from './routes/account.settings';
import { Route as AccountPayoutsRouteImport } from './routes/account.payouts';
import { Route as AccountOpenRouteImport } from './routes/account.open';
import { Route as AccountMembersRouteImport } from './routes/account.members';
import { Route as AccountHomeRouteImport } from './routes/account.home';
import { Route as AccountExchangeRouteImport } from './routes/account.exchange';
import { Route as AccountCardsRouteImport } from './routes/account.cards';
import { Route as AccountBusinessRouteImport } from './routes/account.business';
import { Route as AccountAccountsRouteImport } from './routes/account.accounts';
import { Route as AccountAccountIdRouteImport } from './routes/account.$accountId';
import { Route as R3dsCodeRouteImport } from './routes/3ds.$code';
import { Route as AccountVaultsWithdrawRouteImport } from './routes/account.vaults_.withdraw';
import { Route as AccountVaultsTopupRouteImport } from './routes/account.vaults_.topup';
import { Route as AccountVaultsCreateRouteImport } from './routes/account.vaults_.create';
import { Route as AccountVaultsVaultIdRouteImport } from './routes/account.vaults_.$vaultId';
import { Route as AccountTransferStartRouteImport } from './routes/account.transfer_.start';
import { Route as AccountTransactionsTransactionIdRouteImport } from './routes/account.transactions_.$transactionId';
import { Route as AccountStandingOrdersCreateRouteImport } from './routes/account.standing-orders_.create';
import { Route as AccountSettingsPhoneRouteImport } from './routes/account.settings_.phone';
import { Route as AccountSettingsPasswordRouteImport } from './routes/account.settings_.password';
import { Route as AccountSettingsNameRouteImport } from './routes/account.settings_.name';
import { Route as AccountSettingsKycRouteImport } from './routes/account.settings_.kyc';
import { Route as AccountSettingsEmailRouteImport } from './routes/account.settings_.email';
import { Route as AccountSettings2faRouteImport } from './routes/account.settings_.2fa';
import { Route as AccountPayoutsPayoutIdRouteImport } from './routes/account.payouts_.$payoutId';
import { Route as AccountMembersCustomerIdRouteImport } from './routes/account.members_.$customerId';
import { Route as AccountExchangeStartRouteImport } from './routes/account.exchange_.start';
import { Route as AccountDwtTokenIdRouteImport } from './routes/account.dwt_.$tokenId';
import { Route as AccountCardsCreateRouteImport } from './routes/account.cards_.create';
import { Route as AccountCardsCardIdRouteImport } from './routes/account.cards_.$cardId';
import { Route as AccountBusinessPricingRouteImport } from './routes/account.business_.pricing';
import { Route as AccountBusinessAddMemberRouteImport } from './routes/account.business_.add-member';
import { Route as AccountAccountsCreateRouteImport } from './routes/account.accounts_.create';
import { Route as Account3dsIdRouteImport } from './routes/account.3ds_.$id_';
import { Route as AccountAccountIdNameRouteImport } from './routes/account.$accountId_.name';
import { Route as AccountStandingOrdersOrderIdStepRouteImport } from './routes/account.standing-orders_.$orderId_.$step';
import { Route as AccountPayoutsPayoutIdCreateRouteImport } from './routes/account.payouts_.$payoutId_.create';
import { Route as AccountMembersCustomerIdEditRouteImport } from './routes/account.members_.$customerId_.edit';
import { Route as AccountCardsCardIdSecurityRouteImport } from './routes/account.cards_.$cardId_.security';
import { Route as AccountCardsCardIdNameRouteImport } from './routes/account.cards_.$cardId_.name';
import { Route as AccountCardsCardIdLimitsRouteImport } from './routes/account.cards_.$cardId_.limits';
import { Route as AccountCardsCardIdDetailsRouteImport } from './routes/account.cards_.$cardId_.details';
import { Route as AccountCardsCardIdAccountRouteImport } from './routes/account.cards_.$cardId_.account';
import { Route as AccountBusinessWebhooksAddRouteImport } from './routes/account.business_.webhooks_.add';
import { Route as AccountBusinessWebhooksWebhookIdRouteImport } from './routes/account.business_.webhooks_.$webhookId';

const SwitchRoute = SwitchRouteImport.update({
  id: '/switch',
  path: '/switch',
  getParentRoute: () => rootRouteImport,
} as any);
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any);
const NewBusinessRoute = NewBusinessRouteImport.update({
  id: '/new-business',
  path: '/new-business',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any);
const R3dsRoute = R3dsRouteImport.update({
  id: '/3ds',
  path: '/3ds',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountVaultsRoute = AccountVaultsRouteImport.update({
  id: '/vaults',
  path: '/vaults',
  getParentRoute: () => AccountRoute,
} as any);
const AccountTransferRoute = AccountTransferRouteImport.update({
  id: '/transfer',
  path: '/transfer',
  getParentRoute: () => AccountRoute,
} as any);
const AccountTransactionsRoute = AccountTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AccountRoute,
} as any);
const AccountTopupRoute = AccountTopupRouteImport.update({
  id: '/topup',
  path: '/topup',
  getParentRoute: () => AccountRoute,
} as any);
const AccountStatementsRoute = AccountStatementsRouteImport.update({
  id: '/statements',
  path: '/statements',
  getParentRoute: () => AccountRoute,
} as any);
const AccountStandingOrdersRoute = AccountStandingOrdersRouteImport.update({
  id: '/standing-orders',
  path: '/standing-orders',
  getParentRoute: () => AccountRoute,
} as any);
const AccountSettingsRoute = AccountSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AccountRoute,
} as any);
const AccountPayoutsRoute = AccountPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AccountRoute,
} as any);
const AccountOpenRoute = AccountOpenRouteImport.update({
  id: '/open',
  path: '/open',
  getParentRoute: () => AccountRoute,
} as any);
const AccountMembersRoute = AccountMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AccountRoute,
} as any);
const AccountHomeRoute = AccountHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AccountRoute,
} as any);
const AccountExchangeRoute = AccountExchangeRouteImport.update({
  id: '/exchange',
  path: '/exchange',
  getParentRoute: () => AccountRoute,
} as any);
const AccountCardsRoute = AccountCardsRouteImport.update({
  id: '/cards',
  path: '/cards',
  getParentRoute: () => AccountRoute,
} as any);
const AccountBusinessRoute = AccountBusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => AccountRoute,
} as any);
const AccountAccountsRoute = AccountAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AccountRoute,
} as any);
const AccountAccountIdRoute = AccountAccountIdRouteImport.update({
  id: '/$accountId',
  path: '/$accountId',
  getParentRoute: () => AccountRoute,
} as any);
const R3dsCodeRoute = R3dsCodeRouteImport.update({
  id: '/$code',
  path: '/$code',
  getParentRoute: () => R3dsRoute,
} as any);
const AccountVaultsWithdrawRoute = AccountVaultsWithdrawRouteImport.update({
  id: '/vaults_/withdraw',
  path: '/vaults/withdraw',
  getParentRoute: () => AccountRoute,
} as any);
const AccountVaultsTopupRoute = AccountVaultsTopupRouteImport.update({
  id: '/vaults_/topup',
  path: '/vaults/topup',
  getParentRoute: () => AccountRoute,
} as any);
const AccountVaultsCreateRoute = AccountVaultsCreateRouteImport.update({
  id: '/vaults_/create',
  path: '/vaults/create',
  getParentRoute: () => AccountRoute,
} as any);
const AccountVaultsVaultIdRoute = AccountVaultsVaultIdRouteImport.update({
  id: '/vaults_/$vaultId',
  path: '/vaults/$vaultId',
  getParentRoute: () => AccountRoute,
} as any);
const AccountTransferStartRoute = AccountTransferStartRouteImport.update({
  id: '/transfer_/start',
  path: '/transfer/start',
  getParentRoute: () => AccountRoute,
} as any);
const AccountTransactionsTransactionIdRoute =
  AccountTransactionsTransactionIdRouteImport.update({
    id: '/transactions_/$transactionId',
    path: '/transactions/$transactionId',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountStandingOrdersCreateRoute =
  AccountStandingOrdersCreateRouteImport.update({
    id: '/standing-orders_/create',
    path: '/standing-orders/create',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountSettingsPhoneRoute = AccountSettingsPhoneRouteImport.update({
  id: '/settings_/phone',
  path: '/settings/phone',
  getParentRoute: () => AccountRoute,
} as any);
const AccountSettingsPasswordRoute = AccountSettingsPasswordRouteImport.update({
  id: '/settings_/password',
  path: '/settings/password',
  getParentRoute: () => AccountRoute,
} as any);
const AccountSettingsNameRoute = AccountSettingsNameRouteImport.update({
  id: '/settings_/name',
  path: '/settings/name',
  getParentRoute: () => AccountRoute,
} as any);
const AccountSettingsKycRoute = AccountSettingsKycRouteImport.update({
  id: '/settings_/kyc',
  path: '/settings/kyc',
  getParentRoute: () => AccountRoute,
} as any);
const AccountSettingsEmailRoute = AccountSettingsEmailRouteImport.update({
  id: '/settings_/email',
  path: '/settings/email',
  getParentRoute: () => AccountRoute,
} as any);
const AccountSettings2faRoute = AccountSettings2faRouteImport.update({
  id: '/settings_/2fa',
  path: '/settings/2fa',
  getParentRoute: () => AccountRoute,
} as any);
const AccountPayoutsPayoutIdRoute = AccountPayoutsPayoutIdRouteImport.update({
  id: '/payouts_/$payoutId',
  path: '/payouts/$payoutId',
  getParentRoute: () => AccountRoute,
} as any);
const AccountMembersCustomerIdRoute =
  AccountMembersCustomerIdRouteImport.update({
    id: '/members_/$customerId',
    path: '/members/$customerId',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountExchangeStartRoute = AccountExchangeStartRouteImport.update({
  id: '/exchange_/start',
  path: '/exchange/start',
  getParentRoute: () => AccountRoute,
} as any);
const AccountDwtTokenIdRoute = AccountDwtTokenIdRouteImport.update({
  id: '/dwt_/$tokenId',
  path: '/dwt/$tokenId',
  getParentRoute: () => AccountRoute,
} as any);
const AccountCardsCreateRoute = AccountCardsCreateRouteImport.update({
  id: '/cards_/create',
  path: '/cards/create',
  getParentRoute: () => AccountRoute,
} as any);
const AccountCardsCardIdRoute = AccountCardsCardIdRouteImport.update({
  id: '/cards_/$cardId',
  path: '/cards/$cardId',
  getParentRoute: () => AccountRoute,
} as any);
const AccountBusinessPricingRoute = AccountBusinessPricingRouteImport.update({
  id: '/business_/pricing',
  path: '/business/pricing',
  getParentRoute: () => AccountRoute,
} as any);
const AccountBusinessAddMemberRoute =
  AccountBusinessAddMemberRouteImport.update({
    id: '/business_/add-member',
    path: '/business/add-member',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountAccountsCreateRoute = AccountAccountsCreateRouteImport.update({
  id: '/accounts_/create',
  path: '/accounts/create',
  getParentRoute: () => AccountRoute,
} as any);
const Account3dsIdRoute = Account3dsIdRouteImport.update({
  id: '/3ds_/$id_',
  path: '/3ds/$id',
  getParentRoute: () => AccountRoute,
} as any);
const AccountAccountIdNameRoute = AccountAccountIdNameRouteImport.update({
  id: '/$accountId_/name',
  path: '/$accountId/name',
  getParentRoute: () => AccountRoute,
} as any);
const AccountStandingOrdersOrderIdStepRoute =
  AccountStandingOrdersOrderIdStepRouteImport.update({
    id: '/standing-orders_/$orderId_/$step',
    path: '/standing-orders/$orderId/$step',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountPayoutsPayoutIdCreateRoute =
  AccountPayoutsPayoutIdCreateRouteImport.update({
    id: '/payouts_/$payoutId_/create',
    path: '/payouts/$payoutId/create',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountMembersCustomerIdEditRoute =
  AccountMembersCustomerIdEditRouteImport.update({
    id: '/members_/$customerId_/edit',
    path: '/members/$customerId/edit',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountCardsCardIdSecurityRoute =
  AccountCardsCardIdSecurityRouteImport.update({
    id: '/cards_/$cardId_/security',
    path: '/cards/$cardId/security',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountCardsCardIdNameRoute = AccountCardsCardIdNameRouteImport.update({
  id: '/cards_/$cardId_/name',
  path: '/cards/$cardId/name',
  getParentRoute: () => AccountRoute,
} as any);
const AccountCardsCardIdLimitsRoute =
  AccountCardsCardIdLimitsRouteImport.update({
    id: '/cards_/$cardId_/limits',
    path: '/cards/$cardId/limits',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountCardsCardIdDetailsRoute =
  AccountCardsCardIdDetailsRouteImport.update({
    id: '/cards_/$cardId_/details',
    path: '/cards/$cardId/details',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountCardsCardIdAccountRoute =
  AccountCardsCardIdAccountRouteImport.update({
    id: '/cards_/$cardId_/account',
    path: '/cards/$cardId/account',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountBusinessWebhooksAddRoute =
  AccountBusinessWebhooksAddRouteImport.update({
    id: '/business_/webhooks_/add',
    path: '/business/webhooks/add',
    getParentRoute: () => AccountRoute,
  } as any);
const AccountBusinessWebhooksWebhookIdRoute =
  AccountBusinessWebhooksWebhookIdRouteImport.update({
    id: '/business_/webhooks_/$webhookId',
    path: '/business/webhooks/$webhookId',
    getParentRoute: () => AccountRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/3ds': typeof R3dsRouteWithChildren;
  '/account': typeof AccountRouteWithChildren;
  '/auth': typeof AuthRoute;
  '/new-business': typeof NewBusinessRoute;
  '/signup': typeof SignupRoute;
  '/switch': typeof SwitchRoute;
  '/3ds/$code': typeof R3dsCodeRoute;
  '/account/$accountId': typeof AccountAccountIdRoute;
  '/account/accounts': typeof AccountAccountsRoute;
  '/account/business': typeof AccountBusinessRoute;
  '/account/cards': typeof AccountCardsRoute;
  '/account/exchange': typeof AccountExchangeRoute;
  '/account/home': typeof AccountHomeRoute;
  '/account/members': typeof AccountMembersRoute;
  '/account/open': typeof AccountOpenRoute;
  '/account/payouts': typeof AccountPayoutsRoute;
  '/account/settings': typeof AccountSettingsRoute;
  '/account/standing-orders': typeof AccountStandingOrdersRoute;
  '/account/statements': typeof AccountStatementsRoute;
  '/account/topup': typeof AccountTopupRoute;
  '/account/transactions': typeof AccountTransactionsRoute;
  '/account/transfer': typeof AccountTransferRoute;
  '/account/vaults': typeof AccountVaultsRoute;
  '/account/$accountId/name': typeof AccountAccountIdNameRoute;
  '/account/3ds/$id': typeof Account3dsIdRoute;
  '/account/accounts/create': typeof AccountAccountsCreateRoute;
  '/account/business/add-member': typeof AccountBusinessAddMemberRoute;
  '/account/business/pricing': typeof AccountBusinessPricingRoute;
  '/account/cards/$cardId': typeof AccountCardsCardIdRoute;
  '/account/cards/create': typeof AccountCardsCreateRoute;
  '/account/dwt/$tokenId': typeof AccountDwtTokenIdRoute;
  '/account/exchange/start': typeof AccountExchangeStartRoute;
  '/account/members/$customerId': typeof AccountMembersCustomerIdRoute;
  '/account/payouts/$payoutId': typeof AccountPayoutsPayoutIdRoute;
  '/account/settings/2fa': typeof AccountSettings2faRoute;
  '/account/settings/email': typeof AccountSettingsEmailRoute;
  '/account/settings/kyc': typeof AccountSettingsKycRoute;
  '/account/settings/name': typeof AccountSettingsNameRoute;
  '/account/settings/password': typeof AccountSettingsPasswordRoute;
  '/account/settings/phone': typeof AccountSettingsPhoneRoute;
  '/account/standing-orders/create': typeof AccountStandingOrdersCreateRoute;
  '/account/transactions/$transactionId': typeof AccountTransactionsTransactionIdRoute;
  '/account/transfer/start': typeof AccountTransferStartRoute;
  '/account/vaults/$vaultId': typeof AccountVaultsVaultIdRoute;
  '/account/vaults/create': typeof AccountVaultsCreateRoute;
  '/account/vaults/topup': typeof AccountVaultsTopupRoute;
  '/account/vaults/withdraw': typeof AccountVaultsWithdrawRoute;
  '/account/business/webhooks/$webhookId': typeof AccountBusinessWebhooksWebhookIdRoute;
  '/account/business/webhooks/add': typeof AccountBusinessWebhooksAddRoute;
  '/account/cards/$cardId/account': typeof AccountCardsCardIdAccountRoute;
  '/account/cards/$cardId/details': typeof AccountCardsCardIdDetailsRoute;
  '/account/cards/$cardId/limits': typeof AccountCardsCardIdLimitsRoute;
  '/account/cards/$cardId/name': typeof AccountCardsCardIdNameRoute;
  '/account/cards/$cardId/security': typeof AccountCardsCardIdSecurityRoute;
  '/account/members/$customerId/edit': typeof AccountMembersCustomerIdEditRoute;
  '/account/payouts/$payoutId/create': typeof AccountPayoutsPayoutIdCreateRoute;
  '/account/standing-orders/$orderId/$step': typeof AccountStandingOrdersOrderIdStepRoute;
}
export interface FileRoutesByTo {
  '/3ds': typeof R3dsRouteWithChildren;
  '/account': typeof AccountRouteWithChildren;
  '/auth': typeof AuthRoute;
  '/new-business': typeof NewBusinessRoute;
  '/signup': typeof SignupRoute;
  '/switch': typeof SwitchRoute;
  '/3ds/$code': typeof R3dsCodeRoute;
  '/account/$accountId': typeof AccountAccountIdRoute;
  '/account/accounts': typeof AccountAccountsRoute;
  '/account/business': typeof AccountBusinessRoute;
  '/account/cards': typeof AccountCardsRoute;
  '/account/exchange': typeof AccountExchangeRoute;
  '/account/home': typeof AccountHomeRoute;
  '/account/members': typeof AccountMembersRoute;
  '/account/open': typeof AccountOpenRoute;
  '/account/payouts': typeof AccountPayoutsRoute;
  '/account/settings': typeof AccountSettingsRoute;
  '/account/standing-orders': typeof AccountStandingOrdersRoute;
  '/account/statements': typeof AccountStatementsRoute;
  '/account/topup': typeof AccountTopupRoute;
  '/account/transactions': typeof AccountTransactionsRoute;
  '/account/transfer': typeof AccountTransferRoute;
  '/account/vaults': typeof AccountVaultsRoute;
  '/account/$accountId/name': typeof AccountAccountIdNameRoute;
  '/account/3ds/$id': typeof Account3dsIdRoute;
  '/account/accounts/create': typeof AccountAccountsCreateRoute;
  '/account/business/add-member': typeof AccountBusinessAddMemberRoute;
  '/account/business/pricing': typeof AccountBusinessPricingRoute;
  '/account/cards/$cardId': typeof AccountCardsCardIdRoute;
  '/account/cards/create': typeof AccountCardsCreateRoute;
  '/account/dwt/$tokenId': typeof AccountDwtTokenIdRoute;
  '/account/exchange/start': typeof AccountExchangeStartRoute;
  '/account/members/$customerId': typeof AccountMembersCustomerIdRoute;
  '/account/payouts/$payoutId': typeof AccountPayoutsPayoutIdRoute;
  '/account/settings/2fa': typeof AccountSettings2faRoute;
  '/account/settings/email': typeof AccountSettingsEmailRoute;
  '/account/settings/kyc': typeof AccountSettingsKycRoute;
  '/account/settings/name': typeof AccountSettingsNameRoute;
  '/account/settings/password': typeof AccountSettingsPasswordRoute;
  '/account/settings/phone': typeof AccountSettingsPhoneRoute;
  '/account/standing-orders/create': typeof AccountStandingOrdersCreateRoute;
  '/account/transactions/$transactionId': typeof AccountTransactionsTransactionIdRoute;
  '/account/transfer/start': typeof AccountTransferStartRoute;
  '/account/vaults/$vaultId': typeof AccountVaultsVaultIdRoute;
  '/account/vaults/create': typeof AccountVaultsCreateRoute;
  '/account/vaults/topup': typeof AccountVaultsTopupRoute;
  '/account/vaults/withdraw': typeof AccountVaultsWithdrawRoute;
  '/account/business/webhooks/$webhookId': typeof AccountBusinessWebhooksWebhookIdRoute;
  '/account/business/webhooks/add': typeof AccountBusinessWebhooksAddRoute;
  '/account/cards/$cardId/account': typeof AccountCardsCardIdAccountRoute;
  '/account/cards/$cardId/details': typeof AccountCardsCardIdDetailsRoute;
  '/account/cards/$cardId/limits': typeof AccountCardsCardIdLimitsRoute;
  '/account/cards/$cardId/name': typeof AccountCardsCardIdNameRoute;
  '/account/cards/$cardId/security': typeof AccountCardsCardIdSecurityRoute;
  '/account/members/$customerId/edit': typeof AccountMembersCustomerIdEditRoute;
  '/account/payouts/$payoutId/create': typeof AccountPayoutsPayoutIdCreateRoute;
  '/account/standing-orders/$orderId/$step': typeof AccountStandingOrdersOrderIdStepRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/3ds': typeof R3dsRouteWithChildren;
  '/account': typeof AccountRouteWithChildren;
  '/auth': typeof AuthRoute;
  '/new-business': typeof NewBusinessRoute;
  '/signup': typeof SignupRoute;
  '/switch': typeof SwitchRoute;
  '/3ds/$code': typeof R3dsCodeRoute;
  '/account/$accountId': typeof AccountAccountIdRoute;
  '/account/accounts': typeof AccountAccountsRoute;
  '/account/business': typeof AccountBusinessRoute;
  '/account/cards': typeof AccountCardsRoute;
  '/account/exchange': typeof AccountExchangeRoute;
  '/account/home': typeof AccountHomeRoute;
  '/account/members': typeof AccountMembersRoute;
  '/account/open': typeof AccountOpenRoute;
  '/account/payouts': typeof AccountPayoutsRoute;
  '/account/settings': typeof AccountSettingsRoute;
  '/account/standing-orders': typeof AccountStandingOrdersRoute;
  '/account/statements': typeof AccountStatementsRoute;
  '/account/topup': typeof AccountTopupRoute;
  '/account/transactions': typeof AccountTransactionsRoute;
  '/account/transfer': typeof AccountTransferRoute;
  '/account/vaults': typeof AccountVaultsRoute;
  '/account/$accountId_/name': typeof AccountAccountIdNameRoute;
  '/account/3ds_/$id_': typeof Account3dsIdRoute;
  '/account/accounts_/create': typeof AccountAccountsCreateRoute;
  '/account/business_/add-member': typeof AccountBusinessAddMemberRoute;
  '/account/business_/pricing': typeof AccountBusinessPricingRoute;
  '/account/cards_/$cardId': typeof AccountCardsCardIdRoute;
  '/account/cards_/create': typeof AccountCardsCreateRoute;
  '/account/dwt_/$tokenId': typeof AccountDwtTokenIdRoute;
  '/account/exchange_/start': typeof AccountExchangeStartRoute;
  '/account/members_/$customerId': typeof AccountMembersCustomerIdRoute;
  '/account/payouts_/$payoutId': typeof AccountPayoutsPayoutIdRoute;
  '/account/settings_/2fa': typeof AccountSettings2faRoute;
  '/account/settings_/email': typeof AccountSettingsEmailRoute;
  '/account/settings_/kyc': typeof AccountSettingsKycRoute;
  '/account/settings_/name': typeof AccountSettingsNameRoute;
  '/account/settings_/password': typeof AccountSettingsPasswordRoute;
  '/account/settings_/phone': typeof AccountSettingsPhoneRoute;
  '/account/standing-orders_/create': typeof AccountStandingOrdersCreateRoute;
  '/account/transactions_/$transactionId': typeof AccountTransactionsTransactionIdRoute;
  '/account/transfer_/start': typeof AccountTransferStartRoute;
  '/account/vaults_/$vaultId': typeof AccountVaultsVaultIdRoute;
  '/account/vaults_/create': typeof AccountVaultsCreateRoute;
  '/account/vaults_/topup': typeof AccountVaultsTopupRoute;
  '/account/vaults_/withdraw': typeof AccountVaultsWithdrawRoute;
  '/account/business_/webhooks_/$webhookId': typeof AccountBusinessWebhooksWebhookIdRoute;
  '/account/business_/webhooks_/add': typeof AccountBusinessWebhooksAddRoute;
  '/account/cards_/$cardId_/account': typeof AccountCardsCardIdAccountRoute;
  '/account/cards_/$cardId_/details': typeof AccountCardsCardIdDetailsRoute;
  '/account/cards_/$cardId_/limits': typeof AccountCardsCardIdLimitsRoute;
  '/account/cards_/$cardId_/name': typeof AccountCardsCardIdNameRoute;
  '/account/cards_/$cardId_/security': typeof AccountCardsCardIdSecurityRoute;
  '/account/members_/$customerId_/edit': typeof AccountMembersCustomerIdEditRoute;
  '/account/payouts_/$payoutId_/create': typeof AccountPayoutsPayoutIdCreateRoute;
  '/account/standing-orders_/$orderId_/$step': typeof AccountStandingOrdersOrderIdStepRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/3ds'
    | '/account'
    | '/auth'
    | '/new-business'
    | '/signup'
    | '/switch'
    | '/3ds/$code'
    | '/account/$accountId'
    | '/account/accounts'
    | '/account/business'
    | '/account/cards'
    | '/account/exchange'
    | '/account/home'
    | '/account/members'
    | '/account/open'
    | '/account/payouts'
    | '/account/settings'
    | '/account/standing-orders'
    | '/account/statements'
    | '/account/topup'
    | '/account/transactions'
    | '/account/transfer'
    | '/account/vaults'
    | '/account/$accountId/name'
    | '/account/3ds/$id'
    | '/account/accounts/create'
    | '/account/business/add-member'
    | '/account/business/pricing'
    | '/account/cards/$cardId'
    | '/account/cards/create'
    | '/account/dwt/$tokenId'
    | '/account/exchange/start'
    | '/account/members/$customerId'
    | '/account/payouts/$payoutId'
    | '/account/settings/2fa'
    | '/account/settings/email'
    | '/account/settings/kyc'
    | '/account/settings/name'
    | '/account/settings/password'
    | '/account/settings/phone'
    | '/account/standing-orders/create'
    | '/account/transactions/$transactionId'
    | '/account/transfer/start'
    | '/account/vaults/$vaultId'
    | '/account/vaults/create'
    | '/account/vaults/topup'
    | '/account/vaults/withdraw'
    | '/account/business/webhooks/$webhookId'
    | '/account/business/webhooks/add'
    | '/account/cards/$cardId/account'
    | '/account/cards/$cardId/details'
    | '/account/cards/$cardId/limits'
    | '/account/cards/$cardId/name'
    | '/account/cards/$cardId/security'
    | '/account/members/$customerId/edit'
    | '/account/payouts/$payoutId/create'
    | '/account/standing-orders/$orderId/$step';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/3ds'
    | '/account'
    | '/auth'
    | '/new-business'
    | '/signup'
    | '/switch'
    | '/3ds/$code'
    | '/account/$accountId'
    | '/account/accounts'
    | '/account/business'
    | '/account/cards'
    | '/account/exchange'
    | '/account/home'
    | '/account/members'
    | '/account/open'
    | '/account/payouts'
    | '/account/settings'
    | '/account/standing-orders'
    | '/account/statements'
    | '/account/topup'
    | '/account/transactions'
    | '/account/transfer'
    | '/account/vaults'
    | '/account/$accountId/name'
    | '/account/3ds/$id'
    | '/account/accounts/create'
    | '/account/business/add-member'
    | '/account/business/pricing'
    | '/account/cards/$cardId'
    | '/account/cards/create'
    | '/account/dwt/$tokenId'
    | '/account/exchange/start'
    | '/account/members/$customerId'
    | '/account/payouts/$payoutId'
    | '/account/settings/2fa'
    | '/account/settings/email'
    | '/account/settings/kyc'
    | '/account/settings/name'
    | '/account/settings/password'
    | '/account/settings/phone'
    | '/account/standing-orders/create'
    | '/account/transactions/$transactionId'
    | '/account/transfer/start'
    | '/account/vaults/$vaultId'
    | '/account/vaults/create'
    | '/account/vaults/topup'
    | '/account/vaults/withdraw'
    | '/account/business/webhooks/$webhookId'
    | '/account/business/webhooks/add'
    | '/account/cards/$cardId/account'
    | '/account/cards/$cardId/details'
    | '/account/cards/$cardId/limits'
    | '/account/cards/$cardId/name'
    | '/account/cards/$cardId/security'
    | '/account/members/$customerId/edit'
    | '/account/payouts/$payoutId/create'
    | '/account/standing-orders/$orderId/$step';
  id:
    | '__root__'
    | '/3ds'
    | '/account'
    | '/auth'
    | '/new-business'
    | '/signup'
    | '/switch'
    | '/3ds/$code'
    | '/account/$accountId'
    | '/account/accounts'
    | '/account/business'
    | '/account/cards'
    | '/account/exchange'
    | '/account/home'
    | '/account/members'
    | '/account/open'
    | '/account/payouts'
    | '/account/settings'
    | '/account/standing-orders'
    | '/account/statements'
    | '/account/topup'
    | '/account/transactions'
    | '/account/transfer'
    | '/account/vaults'
    | '/account/$accountId_/name'
    | '/account/3ds_/$id_'
    | '/account/accounts_/create'
    | '/account/business_/add-member'
    | '/account/business_/pricing'
    | '/account/cards_/$cardId'
    | '/account/cards_/create'
    | '/account/dwt_/$tokenId'
    | '/account/exchange_/start'
    | '/account/members_/$customerId'
    | '/account/payouts_/$payoutId'
    | '/account/settings_/2fa'
    | '/account/settings_/email'
    | '/account/settings_/kyc'
    | '/account/settings_/name'
    | '/account/settings_/password'
    | '/account/settings_/phone'
    | '/account/standing-orders_/create'
    | '/account/transactions_/$transactionId'
    | '/account/transfer_/start'
    | '/account/vaults_/$vaultId'
    | '/account/vaults_/create'
    | '/account/vaults_/topup'
    | '/account/vaults_/withdraw'
    | '/account/business_/webhooks_/$webhookId'
    | '/account/business_/webhooks_/add'
    | '/account/cards_/$cardId_/account'
    | '/account/cards_/$cardId_/details'
    | '/account/cards_/$cardId_/limits'
    | '/account/cards_/$cardId_/name'
    | '/account/cards_/$cardId_/security'
    | '/account/members_/$customerId_/edit'
    | '/account/payouts_/$payoutId_/create'
    | '/account/standing-orders_/$orderId_/$step';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  R3dsRoute: typeof R3dsRouteWithChildren;
  AccountRoute: typeof AccountRouteWithChildren;
  AuthRoute: typeof AuthRoute;
  NewBusinessRoute: typeof NewBusinessRoute;
  SignupRoute: typeof SignupRoute;
  SwitchRoute: typeof SwitchRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/switch': {
      id: '/switch';
      path: '/switch';
      fullPath: '/switch';
      preLoaderRoute: typeof SwitchRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/signup': {
      id: '/signup';
      path: '/signup';
      fullPath: '/signup';
      preLoaderRoute: typeof SignupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/new-business': {
      id: '/new-business';
      path: '/new-business';
      fullPath: '/new-business';
      preLoaderRoute: typeof NewBusinessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/auth': {
      id: '/auth';
      path: '/auth';
      fullPath: '/auth';
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account': {
      id: '/account';
      path: '/account';
      fullPath: '/account';
      preLoaderRoute: typeof AccountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/3ds': {
      id: '/3ds';
      path: '/3ds';
      fullPath: '/3ds';
      preLoaderRoute: typeof R3dsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account/vaults': {
      id: '/account/vaults';
      path: '/vaults';
      fullPath: '/account/vaults';
      preLoaderRoute: typeof AccountVaultsRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/transfer': {
      id: '/account/transfer';
      path: '/transfer';
      fullPath: '/account/transfer';
      preLoaderRoute: typeof AccountTransferRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/transactions': {
      id: '/account/transactions';
      path: '/transactions';
      fullPath: '/account/transactions';
      preLoaderRoute: typeof AccountTransactionsRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/topup': {
      id: '/account/topup';
      path: '/topup';
      fullPath: '/account/topup';
      preLoaderRoute: typeof AccountTopupRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/statements': {
      id: '/account/statements';
      path: '/statements';
      fullPath: '/account/statements';
      preLoaderRoute: typeof AccountStatementsRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/standing-orders': {
      id: '/account/standing-orders';
      path: '/standing-orders';
      fullPath: '/account/standing-orders';
      preLoaderRoute: typeof AccountStandingOrdersRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/settings': {
      id: '/account/settings';
      path: '/settings';
      fullPath: '/account/settings';
      preLoaderRoute: typeof AccountSettingsRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/payouts': {
      id: '/account/payouts';
      path: '/payouts';
      fullPath: '/account/payouts';
      preLoaderRoute: typeof AccountPayoutsRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/open': {
      id: '/account/open';
      path: '/open';
      fullPath: '/account/open';
      preLoaderRoute: typeof AccountOpenRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/members': {
      id: '/account/members';
      path: '/members';
      fullPath: '/account/members';
      preLoaderRoute: typeof AccountMembersRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/home': {
      id: '/account/home';
      path: '/home';
      fullPath: '/account/home';
      preLoaderRoute: typeof AccountHomeRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/exchange': {
      id: '/account/exchange';
      path: '/exchange';
      fullPath: '/account/exchange';
      preLoaderRoute: typeof AccountExchangeRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/cards': {
      id: '/account/cards';
      path: '/cards';
      fullPath: '/account/cards';
      preLoaderRoute: typeof AccountCardsRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/business': {
      id: '/account/business';
      path: '/business';
      fullPath: '/account/business';
      preLoaderRoute: typeof AccountBusinessRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/accounts': {
      id: '/account/accounts';
      path: '/accounts';
      fullPath: '/account/accounts';
      preLoaderRoute: typeof AccountAccountsRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/$accountId': {
      id: '/account/$accountId';
      path: '/$accountId';
      fullPath: '/account/$accountId';
      preLoaderRoute: typeof AccountAccountIdRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/3ds/$code': {
      id: '/3ds/$code';
      path: '/$code';
      fullPath: '/3ds/$code';
      preLoaderRoute: typeof R3dsCodeRouteImport;
      parentRoute: typeof R3dsRoute;
    };
    '/account/vaults_/withdraw': {
      id: '/account/vaults_/withdraw';
      path: '/vaults/withdraw';
      fullPath: '/account/vaults/withdraw';
      preLoaderRoute: typeof AccountVaultsWithdrawRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/vaults_/topup': {
      id: '/account/vaults_/topup';
      path: '/vaults/topup';
      fullPath: '/account/vaults/topup';
      preLoaderRoute: typeof AccountVaultsTopupRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/vaults_/create': {
      id: '/account/vaults_/create';
      path: '/vaults/create';
      fullPath: '/account/vaults/create';
      preLoaderRoute: typeof AccountVaultsCreateRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/vaults_/$vaultId': {
      id: '/account/vaults_/$vaultId';
      path: '/vaults/$vaultId';
      fullPath: '/account/vaults/$vaultId';
      preLoaderRoute: typeof AccountVaultsVaultIdRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/transfer_/start': {
      id: '/account/transfer_/start';
      path: '/transfer/start';
      fullPath: '/account/transfer/start';
      preLoaderRoute: typeof AccountTransferStartRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/transactions_/$transactionId': {
      id: '/account/transactions_/$transactionId';
      path: '/transactions/$transactionId';
      fullPath: '/account/transactions/$transactionId';
      preLoaderRoute: typeof AccountTransactionsTransactionIdRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/standing-orders_/create': {
      id: '/account/standing-orders_/create';
      path: '/standing-orders/create';
      fullPath: '/account/standing-orders/create';
      preLoaderRoute: typeof AccountStandingOrdersCreateRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/settings_/phone': {
      id: '/account/settings_/phone';
      path: '/settings/phone';
      fullPath: '/account/settings/phone';
      preLoaderRoute: typeof AccountSettingsPhoneRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/settings_/password': {
      id: '/account/settings_/password';
      path: '/settings/password';
      fullPath: '/account/settings/password';
      preLoaderRoute: typeof AccountSettingsPasswordRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/settings_/name': {
      id: '/account/settings_/name';
      path: '/settings/name';
      fullPath: '/account/settings/name';
      preLoaderRoute: typeof AccountSettingsNameRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/settings_/kyc': {
      id: '/account/settings_/kyc';
      path: '/settings/kyc';
      fullPath: '/account/settings/kyc';
      preLoaderRoute: typeof AccountSettingsKycRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/settings_/email': {
      id: '/account/settings_/email';
      path: '/settings/email';
      fullPath: '/account/settings/email';
      preLoaderRoute: typeof AccountSettingsEmailRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/settings_/2fa': {
      id: '/account/settings_/2fa';
      path: '/settings/2fa';
      fullPath: '/account/settings/2fa';
      preLoaderRoute: typeof AccountSettings2faRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/payouts_/$payoutId': {
      id: '/account/payouts_/$payoutId';
      path: '/payouts/$payoutId';
      fullPath: '/account/payouts/$payoutId';
      preLoaderRoute: typeof AccountPayoutsPayoutIdRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/members_/$customerId': {
      id: '/account/members_/$customerId';
      path: '/members/$customerId';
      fullPath: '/account/members/$customerId';
      preLoaderRoute: typeof AccountMembersCustomerIdRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/exchange_/start': {
      id: '/account/exchange_/start';
      path: '/exchange/start';
      fullPath: '/account/exchange/start';
      preLoaderRoute: typeof AccountExchangeStartRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/dwt_/$tokenId': {
      id: '/account/dwt_/$tokenId';
      path: '/dwt/$tokenId';
      fullPath: '/account/dwt/$tokenId';
      preLoaderRoute: typeof AccountDwtTokenIdRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/cards_/create': {
      id: '/account/cards_/create';
      path: '/cards/create';
      fullPath: '/account/cards/create';
      preLoaderRoute: typeof AccountCardsCreateRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/cards_/$cardId': {
      id: '/account/cards_/$cardId';
      path: '/cards/$cardId';
      fullPath: '/account/cards/$cardId';
      preLoaderRoute: typeof AccountCardsCardIdRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/business_/pricing': {
      id: '/account/business_/pricing';
      path: '/business/pricing';
      fullPath: '/account/business/pricing';
      preLoaderRoute: typeof AccountBusinessPricingRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/business_/add-member': {
      id: '/account/business_/add-member';
      path: '/business/add-member';
      fullPath: '/account/business/add-member';
      preLoaderRoute: typeof AccountBusinessAddMemberRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/accounts_/create': {
      id: '/account/accounts_/create';
      path: '/accounts/create';
      fullPath: '/account/accounts/create';
      preLoaderRoute: typeof AccountAccountsCreateRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/3ds_/$id_': {
      id: '/account/3ds_/$id_';
      path: '/3ds/$id';
      fullPath: '/account/3ds/$id';
      preLoaderRoute: typeof Account3dsIdRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/$accountId_/name': {
      id: '/account/$accountId_/name';
      path: '/$accountId/name';
      fullPath: '/account/$accountId/name';
      preLoaderRoute: typeof AccountAccountIdNameRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/standing-orders_/$orderId_/$step': {
      id: '/account/standing-orders_/$orderId_/$step';
      path: '/standing-orders/$orderId/$step';
      fullPath: '/account/standing-orders/$orderId/$step';
      preLoaderRoute: typeof AccountStandingOrdersOrderIdStepRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/payouts_/$payoutId_/create': {
      id: '/account/payouts_/$payoutId_/create';
      path: '/payouts/$payoutId/create';
      fullPath: '/account/payouts/$payoutId/create';
      preLoaderRoute: typeof AccountPayoutsPayoutIdCreateRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/members_/$customerId_/edit': {
      id: '/account/members_/$customerId_/edit';
      path: '/members/$customerId/edit';
      fullPath: '/account/members/$customerId/edit';
      preLoaderRoute: typeof AccountMembersCustomerIdEditRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/cards_/$cardId_/security': {
      id: '/account/cards_/$cardId_/security';
      path: '/cards/$cardId/security';
      fullPath: '/account/cards/$cardId/security';
      preLoaderRoute: typeof AccountCardsCardIdSecurityRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/cards_/$cardId_/name': {
      id: '/account/cards_/$cardId_/name';
      path: '/cards/$cardId/name';
      fullPath: '/account/cards/$cardId/name';
      preLoaderRoute: typeof AccountCardsCardIdNameRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/cards_/$cardId_/limits': {
      id: '/account/cards_/$cardId_/limits';
      path: '/cards/$cardId/limits';
      fullPath: '/account/cards/$cardId/limits';
      preLoaderRoute: typeof AccountCardsCardIdLimitsRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/cards_/$cardId_/details': {
      id: '/account/cards_/$cardId_/details';
      path: '/cards/$cardId/details';
      fullPath: '/account/cards/$cardId/details';
      preLoaderRoute: typeof AccountCardsCardIdDetailsRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/cards_/$cardId_/account': {
      id: '/account/cards_/$cardId_/account';
      path: '/cards/$cardId/account';
      fullPath: '/account/cards/$cardId/account';
      preLoaderRoute: typeof AccountCardsCardIdAccountRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/business_/webhooks_/add': {
      id: '/account/business_/webhooks_/add';
      path: '/business/webhooks/add';
      fullPath: '/account/business/webhooks/add';
      preLoaderRoute: typeof AccountBusinessWebhooksAddRouteImport;
      parentRoute: typeof AccountRoute;
    };
    '/account/business_/webhooks_/$webhookId': {
      id: '/account/business_/webhooks_/$webhookId';
      path: '/business/webhooks/$webhookId';
      fullPath: '/account/business/webhooks/$webhookId';
      preLoaderRoute: typeof AccountBusinessWebhooksWebhookIdRouteImport;
      parentRoute: typeof AccountRoute;
    };
  }
}

interface R3dsRouteChildren {
  R3dsCodeRoute: typeof R3dsCodeRoute;
}

const R3dsRouteChildren: R3dsRouteChildren = {
  R3dsCodeRoute: R3dsCodeRoute,
};

const R3dsRouteWithChildren = R3dsRoute._addFileChildren(R3dsRouteChildren);

interface AccountRouteChildren {
  AccountAccountIdRoute: typeof AccountAccountIdRoute;
  AccountAccountsRoute: typeof AccountAccountsRoute;
  AccountBusinessRoute: typeof AccountBusinessRoute;
  AccountCardsRoute: typeof AccountCardsRoute;
  AccountExchangeRoute: typeof AccountExchangeRoute;
  AccountHomeRoute: typeof AccountHomeRoute;
  AccountMembersRoute: typeof AccountMembersRoute;
  AccountOpenRoute: typeof AccountOpenRoute;
  AccountPayoutsRoute: typeof AccountPayoutsRoute;
  AccountSettingsRoute: typeof AccountSettingsRoute;
  AccountStandingOrdersRoute: typeof AccountStandingOrdersRoute;
  AccountStatementsRoute: typeof AccountStatementsRoute;
  AccountTopupRoute: typeof AccountTopupRoute;
  AccountTransactionsRoute: typeof AccountTransactionsRoute;
  AccountTransferRoute: typeof AccountTransferRoute;
  AccountVaultsRoute: typeof AccountVaultsRoute;
  AccountAccountIdNameRoute: typeof AccountAccountIdNameRoute;
  Account3dsIdRoute: typeof Account3dsIdRoute;
  AccountAccountsCreateRoute: typeof AccountAccountsCreateRoute;
  AccountBusinessAddMemberRoute: typeof AccountBusinessAddMemberRoute;
  AccountBusinessPricingRoute: typeof AccountBusinessPricingRoute;
  AccountCardsCardIdRoute: typeof AccountCardsCardIdRoute;
  AccountCardsCreateRoute: typeof AccountCardsCreateRoute;
  AccountDwtTokenIdRoute: typeof AccountDwtTokenIdRoute;
  AccountExchangeStartRoute: typeof AccountExchangeStartRoute;
  AccountMembersCustomerIdRoute: typeof AccountMembersCustomerIdRoute;
  AccountPayoutsPayoutIdRoute: typeof AccountPayoutsPayoutIdRoute;
  AccountSettings2faRoute: typeof AccountSettings2faRoute;
  AccountSettingsEmailRoute: typeof AccountSettingsEmailRoute;
  AccountSettingsKycRoute: typeof AccountSettingsKycRoute;
  AccountSettingsNameRoute: typeof AccountSettingsNameRoute;
  AccountSettingsPasswordRoute: typeof AccountSettingsPasswordRoute;
  AccountSettingsPhoneRoute: typeof AccountSettingsPhoneRoute;
  AccountStandingOrdersCreateRoute: typeof AccountStandingOrdersCreateRoute;
  AccountTransactionsTransactionIdRoute: typeof AccountTransactionsTransactionIdRoute;
  AccountTransferStartRoute: typeof AccountTransferStartRoute;
  AccountVaultsVaultIdRoute: typeof AccountVaultsVaultIdRoute;
  AccountVaultsCreateRoute: typeof AccountVaultsCreateRoute;
  AccountVaultsTopupRoute: typeof AccountVaultsTopupRoute;
  AccountVaultsWithdrawRoute: typeof AccountVaultsWithdrawRoute;
  AccountBusinessWebhooksWebhookIdRoute: typeof AccountBusinessWebhooksWebhookIdRoute;
  AccountBusinessWebhooksAddRoute: typeof AccountBusinessWebhooksAddRoute;
  AccountCardsCardIdAccountRoute: typeof AccountCardsCardIdAccountRoute;
  AccountCardsCardIdDetailsRoute: typeof AccountCardsCardIdDetailsRoute;
  AccountCardsCardIdLimitsRoute: typeof AccountCardsCardIdLimitsRoute;
  AccountCardsCardIdNameRoute: typeof AccountCardsCardIdNameRoute;
  AccountCardsCardIdSecurityRoute: typeof AccountCardsCardIdSecurityRoute;
  AccountMembersCustomerIdEditRoute: typeof AccountMembersCustomerIdEditRoute;
  AccountPayoutsPayoutIdCreateRoute: typeof AccountPayoutsPayoutIdCreateRoute;
  AccountStandingOrdersOrderIdStepRoute: typeof AccountStandingOrdersOrderIdStepRoute;
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountAccountIdRoute: AccountAccountIdRoute,
  AccountAccountsRoute: AccountAccountsRoute,
  AccountBusinessRoute: AccountBusinessRoute,
  AccountCardsRoute: AccountCardsRoute,
  AccountExchangeRoute: AccountExchangeRoute,
  AccountHomeRoute: AccountHomeRoute,
  AccountMembersRoute: AccountMembersRoute,
  AccountOpenRoute: AccountOpenRoute,
  AccountPayoutsRoute: AccountPayoutsRoute,
  AccountSettingsRoute: AccountSettingsRoute,
  AccountStandingOrdersRoute: AccountStandingOrdersRoute,
  AccountStatementsRoute: AccountStatementsRoute,
  AccountTopupRoute: AccountTopupRoute,
  AccountTransactionsRoute: AccountTransactionsRoute,
  AccountTransferRoute: AccountTransferRoute,
  AccountVaultsRoute: AccountVaultsRoute,
  AccountAccountIdNameRoute: AccountAccountIdNameRoute,
  Account3dsIdRoute: Account3dsIdRoute,
  AccountAccountsCreateRoute: AccountAccountsCreateRoute,
  AccountBusinessAddMemberRoute: AccountBusinessAddMemberRoute,
  AccountBusinessPricingRoute: AccountBusinessPricingRoute,
  AccountCardsCardIdRoute: AccountCardsCardIdRoute,
  AccountCardsCreateRoute: AccountCardsCreateRoute,
  AccountDwtTokenIdRoute: AccountDwtTokenIdRoute,
  AccountExchangeStartRoute: AccountExchangeStartRoute,
  AccountMembersCustomerIdRoute: AccountMembersCustomerIdRoute,
  AccountPayoutsPayoutIdRoute: AccountPayoutsPayoutIdRoute,
  AccountSettings2faRoute: AccountSettings2faRoute,
  AccountSettingsEmailRoute: AccountSettingsEmailRoute,
  AccountSettingsKycRoute: AccountSettingsKycRoute,
  AccountSettingsNameRoute: AccountSettingsNameRoute,
  AccountSettingsPasswordRoute: AccountSettingsPasswordRoute,
  AccountSettingsPhoneRoute: AccountSettingsPhoneRoute,
  AccountStandingOrdersCreateRoute: AccountStandingOrdersCreateRoute,
  AccountTransactionsTransactionIdRoute: AccountTransactionsTransactionIdRoute,
  AccountTransferStartRoute: AccountTransferStartRoute,
  AccountVaultsVaultIdRoute: AccountVaultsVaultIdRoute,
  AccountVaultsCreateRoute: AccountVaultsCreateRoute,
  AccountVaultsTopupRoute: AccountVaultsTopupRoute,
  AccountVaultsWithdrawRoute: AccountVaultsWithdrawRoute,
  AccountBusinessWebhooksWebhookIdRoute: AccountBusinessWebhooksWebhookIdRoute,
  AccountBusinessWebhooksAddRoute: AccountBusinessWebhooksAddRoute,
  AccountCardsCardIdAccountRoute: AccountCardsCardIdAccountRoute,
  AccountCardsCardIdDetailsRoute: AccountCardsCardIdDetailsRoute,
  AccountCardsCardIdLimitsRoute: AccountCardsCardIdLimitsRoute,
  AccountCardsCardIdNameRoute: AccountCardsCardIdNameRoute,
  AccountCardsCardIdSecurityRoute: AccountCardsCardIdSecurityRoute,
  AccountMembersCustomerIdEditRoute: AccountMembersCustomerIdEditRoute,
  AccountPayoutsPayoutIdCreateRoute: AccountPayoutsPayoutIdCreateRoute,
  AccountStandingOrdersOrderIdStepRoute: AccountStandingOrdersOrderIdStepRoute,
};

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  R3dsRoute: R3dsRouteWithChildren,
  AccountRoute: AccountRouteWithChildren,
  AuthRoute: AuthRoute,
  NewBusinessRoute: NewBusinessRoute,
  SignupRoute: SignupRoute,
  SwitchRoute: SwitchRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
